import React from 'react';

import cn from 'classnames';
import { useDispatch } from 'react-redux';

import IconFemtasy from 'components/IconFemtasy';
import Typography from 'components/Typography';

import { BannerShape, showBanner } from 'store/modules/banner';
import { closeAddStoryToPlaylist } from 'store/modules/playlist';

import './style.scss';

interface ListItemProps {
  className?: string;
  onClick?: Function;
  selected?: boolean;
  text: string;
}

const ListItem = ({
  className,
  onClick,
  text,
  selected = false,
}: ListItemProps) => {
  const [isSelected, setIsSelected] = React.useState(selected);

  return (
    <div
      className={cn('ListItem', className)}
      onClick={() => {
        setIsSelected(!isSelected);
        onClick && onClick();
      }}
    >
      <IconFemtasy icon={isSelected ? 'Checkboxfilled' : 'Checkboxline'} />
      <Typography className="text" variant="h4">
        {text}
      </Typography>
    </div>
  );
};

export const useCloseOverlayPageAndShowBanner = () => {
  const dispatch = useDispatch();

  const closeOverlayPageAndShowBanner = (bannerMessage: string) => {
    const topBanner: BannerShape = {
      message: { id: bannerMessage },
      displaySeconds: 3,
    };

    dispatch(showBanner(topBanner));
    dispatch(closeAddStoryToPlaylist());
  };

  return closeOverlayPageAndShowBanner;
};

export default ListItem;
